<div class="ya-bottomsheet-container ya-typography">
    <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
    <div class="ya-bottomsheet-content-center">
      <div class="ya-bottomsheet-title-icon">
        <div class="inline-icon" inlineSVG="{{modalData.icon}}"></div>
      </div>
      <h2>{{modalData.title}}</h2>
      <div>
        <p class="content-desc">{{evaluateLanguageString(modalData.description)}}</p>
      </div>
      <div class="ya-dialog-action">
        <div class="ya-button-group-wrapper">
          <div class="ya-button-group-container">
            <div class="ya-button-container">
              <button mat-flat-button (click)="ConfirmBtn()">
                <span>{{evaluateLanguageString(modalData.buttonTextAccept)}}</span>
              </button>
            </div>
            <div class="ya-button-container">
              <button mat-stroked-button (click)="DenyBtn()">
                <span>{{evaluateLanguageString(modalData.buttonTextDeny)}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p class="content-text">{{evaluateLanguageString(modalData.notice)}}</p>
      </div>
    </div>
  </div>